var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 20",
    style: {
      enableBackground: "new 0 0 400 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#39b39b;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.4,14.97c20.96-1.23,41.92-2.47,62.88-3.7c0.01-0.11,0.03-0.22,0.04-0.33c-1.98,0-3.96-0.02-5.94,0 c-35.14,0.43-70.28,0.85-105.41,1.34c-4.3,0.06-7.41-0.45-9.29-2.52c-2.05-2.27-1.62-2.78,3.31-2.89 c12.65-0.3,25.29-0.58,37.94-0.83c66.27-1.27,132.56-1.86,198.86-1c31.46,0.41,62.89,1.44,94.35,2.03 c12.64,0.23,25.3,0.02,37.96,0.01c6.96,0,9.6,1.45,9.37,4.91c-0.12,1.84-1.63,2.33-5.31,2.26c-36.61-0.7-73.25-1.94-109.85-1.8 c-60.95,0.24-121.89,1.36-182.82,2.16c-8.64,0.11-17.27,0.49-25.91,0.75C67.51,15.23,67.45,15.1,67.4,14.97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.febe919f9eff4d91ff8687ee0cfbea3f.svg";
export { ForwardRef as ReactComponent };